/* App — hero phone: the 4 screens loop automatically, tab indicator follows. */
(function () {
  function init(root) {
    if (!root || root._apHero) return;
    root._apHero = true;
    var D = window.Dozzee || {};
    if (D.reduce || !D.gsap) return;
    D.gsap(function (gsap) {
      var scr = Array.prototype.slice.call(root.querySelectorAll('[data-scr]')), ind = root.querySelector('[data-tab-ind]');
      if (scr.length < 2) return;
      var dir = (D.settings && D.settings.rtl) ? -1 : 1;
      root._apCtx = gsap.context(function () {
        var tl = gsap.timeline({ repeat: -1 });
        for (var i = 0; i < scr.length; i++) {
          var n = (i + 1) % scr.length;
          tl.to({}, { duration: 2.8 })
            .to(scr[i], { autoAlpha: 0, x: -24 * dir, duration: 0.35, ease: 'power1.in' })
            .fromTo(scr[n], { autoAlpha: 0, x: 30 * dir }, { autoAlpha: 1, x: 0, duration: 0.4, ease: 'power2.out' }, '<0.15');
          if (ind) tl.to(ind, { xPercent: 100 * n * dir, duration: 0.4, ease: 'power2.inOut' }, '<');
        }
        root._apTl = tl;
        // pause the loop while the phone is off-screen
        if ('IntersectionObserver' in window) {
          root._apIo = new IntersectionObserver(function (es) { es.forEach(function (e) { e.isIntersecting ? tl.resume() : tl.pause(); }); });
          root._apIo.observe(root);
        }
      }, root);
    });
  }
  function destroy(root) {
    if (!root) return;
    if (root._apIo) root._apIo.disconnect();
    if (root._apCtx) root._apCtx.revert();
    root._apIo = null; root._apCtx = null; root._apHero = false;
  }
  function all(scope) { (scope || document).querySelectorAll('[data-section-type="app-hero"]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
  else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { e.target.querySelectorAll('[data-section-type="app-hero"]').forEach(destroy); });
})();
